import {  postRequest } from "./RequestConfig";

export const setUser = async (data) => {
  try {
    const response = await postRequest(`maintenance/loggedIn/user`,data);
    return response;
  } catch (error) {
    throw error;
  }
};